import { restaurantListSlice } from "../reducers/restaurantReducers";
import {
  restaurantDetailsSlice,
  reservationsFromRestaurantSlice,
  reservationAcceptSlice,
  availabeTablesToChangeSlice,
  changeTablesSlice,
  restaurantOpenDaysOfTheWeekSlice,
  estimatedTimeCustomersSpendSlice,
  openClosedExceptionsSlice,
  placeOfTableSlice,
  tablesSlice,
  fetchHoursEachTimeSlice,
  fetchConnectTablesSlice,
  create_confirmationSlice,
  getReservationSumsSlice,
  customerAttendUpdateSlice,
  getTutorialStepsSlice,
  createRestaurantSlice,
  destroyItemSlice,
  restaurantNotificationsSlice,
  restaurantCreatePaymentIntentSlice,
  filtersSlice,
} from "../reducers/restaurantReducers";
import { fetchReservationCustomerMenu } from "../actions/reservationsActions";
import { api } from "../App";
import qs from "qs";

const { startCreateConfirmation, createSuccess, createError } =
  create_confirmationSlice.actions;

const { listTheRestaurants, startListingRestaurants, errorlistRestaurants } =
  restaurantListSlice.actions;

export const fetchRestaurantList = () => async (dispatch, getState) => {
  try {
    dispatch(startListingRestaurants());

    const {
      userLogin: { userInfo },
    } = getState();

    if (!userInfo?.token) {
      return;
    }

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const response = await api.get("/restaurants/restaurantsFromUser", config);
    dispatch(listTheRestaurants(response.data));
  } catch (error) {
    dispatch(
      errorlistRestaurants(error.response?.data?.detail || error.message),
    );
  }
};

const {
  startGetRestaurant,
  getRestaurant,
  errorGetRestaurants,
  RestaurantDetailsReset,
} = restaurantDetailsSlice.actions;

export const fetchRestaurantDetails =
  (id, reset = false) =>
  async (dispatch, getState) => {
    if (reset) {
      dispatch(RestaurantDetailsReset());
    } else {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      try {
        dispatch(startGetRestaurant());
        await api
          .get(`/restaurants/restaurantfromuser/${id}`, config)
          .then((response) => dispatch(getRestaurant(response.data)));
      } catch (error) {
        dispatch(
          errorGetRestaurants(
            error.response && error.response.data.detail
              ? error.response.data.detail
              : error.message,
          ),
        );
      }
    }
  };

export const resetRestaurantDetailsNow = () => async (dispatch, getState) => {
  dispatch(RestaurantDetailsReset());
};

export const updateRestaurant = (id, params) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(startGetRestaurant());
    await api
      .patch(`/restaurants/restaurantfromuser/${id}`, params, config)
      .then((response) => dispatch(getRestaurant(response.data)));
  } catch (error) {
    dispatch(
      errorGetRestaurants(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

// reducers exports
export const {
  getReservationsFromRestaurantRequest,
  getReservationsFromRestaurantSucess,
  getReservationsFromRestaurantError,
  getReservationsFromRestaurantNottingToChange,
  getAllReservationsFromRestaurantRequest,
  getAllReservationsFromRestaurantSucess,
  getAllReservationsFromRestaurantError,
  getLastReservationsWithChatMessagesRequest,
  getLastReservationsWithChatMessagesSuccess,
  getLastReservationsWithChatMessagesError,
} = reservationsFromRestaurantSlice.actions;

export const fetchReservations =
  (restaurant_id, dateFilter, statusFilter, autocheck = false) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      const params = {};
      if (dateFilter) params.dateFilter = dateFilter;
      if (statusFilter && statusFilter !== "Todos")
        params.status = statusFilter;
      else if (statusFilter && statusFilter === "all_pending_reservations")
        params.status = statusFilter;

      if (!autocheck) {
        dispatch(getReservationsFromRestaurantRequest());
      }
      const { data } = await api.get(
        `/restaurants/${restaurant_id}/reservations/`,
        {
          params: params,
        },
        config,
      );
      const existingData = getState().reservationsFromRestaurant.reservations; // Access existing data from Redux state
      if (JSON.stringify(data) !== JSON.stringify(existingData)) {
        dispatch(getReservationsFromRestaurantSucess(data));
      } else {
        dispatch(getReservationsFromRestaurantNottingToChange());
      }
    } catch (error) {
      dispatch(
        getReservationsFromRestaurantError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const fetchAllReservations =
  (restaurant_id, dateFilter, shift, placeOfTable, statusFilter) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      const params = {};
      if (dateFilter) params.dateFilter = dateFilter;
      if (shift && shift != "Todos") params.shift = shift;
      if (placeOfTable && placeOfTable != "Todos")
        params.place_of_table = placeOfTable;
      if (statusFilter && statusFilter != "Todos") params.status = statusFilter;
      else if (statusFilter && statusFilter == "all_pending_reservations")
        params.status = statusFilter;
      dispatch(getAllReservationsFromRestaurantRequest());
      const { data } = await api.get(
        `/restaurants/${restaurant_id}/reservations/`,
        {
          params: params,
        },
        config,
      );
      const existingData =
        getState().reservationsFromRestaurant.AllReservations; // Access existing data from Redux state
      if (JSON.stringify(data) !== JSON.stringify(existingData)) {
        dispatch(getAllReservationsFromRestaurantSucess(data));
      } else {
        dispatch(getReservationsFromRestaurantNottingToChange());
      }
    } catch (error) {
      dispatch(
        getAllReservationsFromRestaurantError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const fetchLastReservationsWithChatMessages =
  (restaurant_id, search = "") =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = userInfo
        ? {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        : {
            headers: { nothing: "nothing" },
          };

      dispatch(getLastReservationsWithChatMessagesRequest());

      const params = {};
      if (search) params.search = search;
      const { data } = await api.get(
        `/restaurants/${restaurant_id}/reservations/with-chat-messages/`,
        { params },
        config,
      );

      dispatch(getLastReservationsWithChatMessagesSuccess(data));
    } catch (error) {
      dispatch(
        getLastReservationsWithChatMessagesError(
          error.response?.data?.detail || error.message,
        ),
      );
    }
  };

export const fetchReservation =
  (reservation_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(getReservationsFromRestaurantRequest());

      await api
        .get(`/restaurants/${reservation_id}/reservations/`, config)
        .then((response) => dispatch(listTheRestaurants(response.data)));
    } catch (error) {
      dispatch(
        errorlistRestaurants(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const {
  reservationAcceptRequest,
  reservationAcceptSucess,
  reservationAcceptError,
} = reservationAcceptSlice.actions;

export const postReservationAccept =
  (
    token,
    multiple_reservations = false,
    rejectEdition = false,
    notify_customer,
  ) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(reservationAcceptRequest());
      await api
        .post(
          `/restaurants/accept_reservation_from_restaurant/`,
          {
            token: token,
            multiple_reservations: multiple_reservations ? 1 : 0,
            notify_customer: notify_customer,
            rejectEdition: rejectEdition ? 1 : 0,
          },
          config,
        )
        .then((response) => dispatch(reservationAcceptSucess(response.data)));
    } catch (error) {
      dispatch(
        reservationAcceptError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const {
  availabeTablesToChangeRequest,
  availabeTablesToChangeSucess,
  availabeTablesToChangeError,
} = availabeTablesToChangeSlice.actions;

export const tablesToChange =
  (id, date, time, token, numPeople) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(availabeTablesToChangeRequest());

      await api
        .get(
          `/restaurants/available_tables/${id}/${date}/${time}/${token}/${numPeople}`,
          config,
        )
        .then((response) =>
          dispatch(availabeTablesToChangeSucess(response.data)),
        );
    } catch (error) {
      dispatch(
        availabeTablesToChangeError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const { changeTableRequest, changeTableSucess, changeTableError } =
  changeTablesSlice.actions;
export const changeTables = (token, list, id) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(changeTableRequest());
    const data = await api.post(
      `/restaurants/update_reservation_tables/`,
      { token: token, list: list, id: id },
      config,
    );
    dispatch(changeTableSucess(data));
    dispatch(fetchReservationCustomerMenu(token, "no"));
  } catch (error) {
    dispatch(
      changeTableError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

/* time management */
const { startFetchingOpenDays, fetchOpenDaysSuccess, fetchOpenDaysError } =
  restaurantOpenDaysOfTheWeekSlice.actions;

export const fetchRestaurantOpenDays =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingOpenDays());
      await api
        .get(`/restaurants/${restaurant_id}/opentimes`, config)
        .then((response) => dispatch(fetchOpenDaysSuccess(response.data)));
    } catch (error) {
      dispatch(
        fetchOpenDaysError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  startFetchingEstimatedTime,
  fetchEstimatedTimeSuccess,
  fetchEstimatedTimeError,
} = estimatedTimeCustomersSpendSlice.actions;

export const fetchEstimatedTimeCustomersSpend =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingEstimatedTime());
      await api
        .get(`/restaurants/${restaurant_id}/estimatedtime`, config)
        .then((response) => dispatch(fetchEstimatedTimeSuccess(response.data)));
    } catch (error) {
      dispatch(
        fetchEstimatedTimeError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  startFetchingOpenClosedExceptions,
  fetchOpenClosedExceptionsSuccess,
  fetchOpenClosedExceptionsError,
} = openClosedExceptionsSlice.actions;

export const fetchOpenClosedExceptions =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingOpenClosedExceptions());
      await api
        .get(`/restaurants/${restaurant_id}/OpenClosedExceptions`, config)
        .then((response) =>
          dispatch(fetchOpenClosedExceptionsSuccess(response.data)),
        );
    } catch (error) {
      dispatch(
        fetchOpenClosedExceptionsError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };
/* time management  patch*/
export const patchRestaurantOpenDays =
  (restaurant_id, pk, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingOpenDays());
      await api
        .patch(`/restaurants/${restaurant_id}/opentimes/${pk}/`, params, config)
        .then((response) => dispatch(fetchOpenDaysSuccess(response.data)));
      dispatch(fetchRestaurantOpenDays(restaurant_id));
    } catch (error) {
      dispatch(
        fetchOpenDaysError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const patchEstimatedTimeCustomersSpend =
  (restaurant_id, pk, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingEstimatedTime());
      await api
        .patch(
          `/restaurants/${restaurant_id}/estimatedtime/${pk}/`,
          params,
          config,
        )
        .then((response) => dispatch(fetchEstimatedTimeSuccess(response.data)));
      dispatch(fetchEstimatedTimeCustomersSpend(restaurant_id));
    } catch (error) {
      dispatch(
        fetchEstimatedTimeError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const patchOpenClosedExceptions =
  (restaurant_id, pk, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingOpenClosedExceptions());
      await api
        .patch(
          `/restaurants/${restaurant_id}/OpenClosedExceptions/${pk}`,
          params,
          config,
        )
        .then((response) =>
          dispatch(fetchOpenClosedExceptionsSuccess(response.data)),
        );
    } catch (error) {
      dispatch(
        fetchOpenClosedExceptionsError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

/* time management  create */
export const createRestaurantOpenDays =
  (restaurant_id, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startCreateConfirmation());
      await api
        .post(`/restaurants/${restaurant_id}/opentimes/`, params, config)
        .then((response) => dispatch(createSuccess(response.data)));
      dispatch(fetchRestaurantOpenDays(restaurant_id));
    } catch (error) {
      dispatch(
        createError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const createEstimatedTimeCustomersSpend =
  (restaurant_id, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startCreateConfirmation());
      await api
        .post(`/restaurants/${restaurant_id}/estimatedtime/`, params, config)
        .then((response) => dispatch(createSuccess(response.data)));
      dispatch(fetchEstimatedTimeCustomersSpend(restaurant_id));
    } catch (error) {
      dispatch(
        createError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const createOpenClosedExceptions =
  (restaurant_id, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startCreateConfirmation());
      await api
        .post(
          `/restaurants/${restaurant_id}/OpenClosedExceptions/`,
          params,
          config,
        )
        .then((response) => dispatch(createSuccess(response.data)));
      dispatch(fetchOpenClosedExceptions(restaurant_id));
    } catch (error) {
      dispatch(
        createError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

/* Tables managements */

const {
  startFetchingPlaceOfTable,
  fetchPlaceOfTableSuccess,
  fetchPlaceOfTableError,
} = placeOfTableSlice.actions;

export const fetchPlaceOfTable =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingPlaceOfTable());
      await api
        .get(`/restaurants/${restaurant_id}/placeoftable`, config)
        .then((response) => dispatch(fetchPlaceOfTableSuccess(response.data)));
    } catch (error) {
      dispatch(
        fetchPlaceOfTableError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  startFetchingTables,
  fetchTablesSuccess,
  fetchTablesError,
  startBulkUpdateTables,
  bulkUpdateTablesSuccess,
  bulkUpdateTablesError,
} = tablesSlice.actions;

export const fetchTables = (restaurant_id) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(startFetchingTables());
    await api
      .get(`/restaurants/${restaurant_id}/tables/`, config)
      .then((response) => dispatch(fetchTablesSuccess(response.data)));
  } catch (error) {
    dispatch(
      fetchTablesError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

// NEW: bulk patch selected tables
export const bulkUpdateTables =
  (restaurant_id, updates) => async (dispatch, getState) => {
    // updates = [{ id, table_name?, number_of_seats?, can_connect_tables? }, ...]
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = userInfo
        ? {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        : { headers: { "Content-type": "application/json" } };

      dispatch(startBulkUpdateTables());
      const { data } = await api.patch(
        `/restaurants/${restaurant_id}/tables/bulk-update/`,
        { updates },
        config,
      );

      // data is the array of updated rows returned by the API
      dispatch(bulkUpdateTablesSuccess(data));

      // Optional: if you prefer full refresh, uncomment:
      // await dispatch(fetchTables(restaurant_id));
    } catch (error) {
      dispatch(
        bulkUpdateTablesError(error?.response?.data?.detail || error.message),
      );
    }
  };

const {
  startFetchingConnectTables,
  fetchcanConnectTablesSuccess,
  fetchConnectTablesError,
} = fetchConnectTablesSlice.actions;

export const fetchConnectTablesConfig =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startFetchingConnectTables());
      await api
        .get(
          `/restaurants/${restaurant_id}/numberofpeopleperconnectedtable/`,
          config,
        )
        .then((response) =>
          dispatch(fetchcanConnectTablesSuccess(response.data)),
        );
    } catch (error) {
      dispatch(
        fetchConnectTablesError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

/* Tables management patch */

export const patchPlaceOfTable =
  (restaurant_id, pk, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startCreateConfirmation());
      await api
        .patch(
          `/restaurants/${restaurant_id}/placeoftable/${pk}/`,
          params,
          config,
        )
        .then((response) => dispatch(createSuccess(response.data)));
    } catch (error) {
      dispatch(
        createError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const patchTables =
  (restaurant_id, pk, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startCreateConfirmation());
      await api
        .patch(`/restaurants/${restaurant_id}/tables/${pk}/`, params, config)
        .then((response) => dispatch(createSuccess(response.data)));
      dispatch(fetchTables(restaurant_id));
    } catch (error) {
      dispatch(
        createError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

/* Tables management create */

export const createPlaceOfTable =
  (restaurant_id, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startCreateConfirmation());
      await api
        .post(`/restaurants/${restaurant_id}/placeoftable/`, params, config)
        .then((response) => dispatch(createSuccess(response.data)));
      dispatch(fetchPlaceOfTable(restaurant_id));
    } catch (error) {
      dispatch(
        createError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const createTables =
  (restaurant_id, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startCreateConfirmation());
      await api
        .post(`/restaurants/${restaurant_id}/tables/`, params, config)
        .then((response) => dispatch(createSuccess(response.data)));
      dispatch(fetchTables(restaurant_id));
    } catch (error) {
      dispatch(
        createError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const { startFetchingHoursEach, fetchHoursEachSuccess, fetchHoursEachError } =
  fetchHoursEachTimeSlice.actions;

export const fetchHoursEach = (restaurant_id) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(startFetchingHoursEach());
    await api
      .get(`/restaurants/time_slots/${restaurant_id}`, config)
      .then((response) => dispatch(fetchHoursEachSuccess(response.data)));
  } catch (error) {
    dispatch(
      fetchHoursEachError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

const {
  startGetReservationSums,
  getReservationSumsSuccess,
  getReservationSumsError,
} = getReservationSumsSlice.actions;

export const getReservationSums =
  (restaurant_id, day) => async (dispatch, getState) => {
    const requestKey = `${restaurant_id}-${day}-${Date.now()}`;

    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: userInfo
          ? {
              "Content-type": "application/json",
              Authorization: `Bearer ${userInfo.token}`,
            }
          : {
              "Content-type": "application/json",
            },
        params: {
          _t: Date.now(),
        },
      };

      dispatch(startGetReservationSums({ requestKey }));

      const response = await api.get(
        `/restaurants/reservation-sums/${restaurant_id}/${day}`,
        config,
      );

      dispatch(
        getReservationSumsSuccess({
          date_summary: response.data?.date_summary || [],
          filter_names: response.data?.filter_names || [],
          requestKey,
        }),
      );
    } catch (error) {
      dispatch(
        getReservationSumsError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  startCustomerAttendUpdate,
  customerAttendUpdateSuccess,
  customerAttendUpdateError,
  startArrangedTableUpdate,
  arrangedTableSuccess,
  ArrangedTableError,
  startChangeTableNumber,
  changeTableNumberSuccess,
  changeTableNumberError,
  customerAttendUpdateReset,
  TableReadyMessageStart,
  TableReadyMessageSuccess,
  TableReadyMessageError,
} = customerAttendUpdateSlice.actions;

export const updateReservationStatus =
  (reservation_id, status, options = {}) =>
  async (dispatch, getState) => {
    dispatch(startCustomerAttendUpdate());

    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          ...(userInfo?.token
            ? { Authorization: `Bearer ${userInfo.token}` }
            : {}),
        },
      };

      const payload = {
        reservation_id,
        status,
      };

      if (typeof options.sendNotification === "boolean") {
        payload.send_notification = options.sendNotification;
      }
      console.log("inside actions payload: ", payload, options);
      const response = await api.patch(
        `/restaurants/update_reservation_status/`,
        payload,
        config,
      );

      dispatch(customerAttendUpdateSuccess(response.data));
    } catch (error) {
      const responseData = error.response?.data;

      const debugError = {
        statusCode: error.response?.status || null,
        backendError:
          responseData?.error ||
          responseData?.detail ||
          responseData?.message ||
          responseData?.exception_message ||
          error.message,
        backendResponse: responseData || null,
        sentPayload: {
          reservation_id,
          status,
          ...(typeof options.sendNotification === "boolean"
            ? { send_notification: options.sendNotification }
            : {}),
        },
      };

      console.error("updateReservationStatus failed:", debugError);

      dispatch(customerAttendUpdateError(debugError));
    }
  };

export const fetchTableConnections =
  (restaurantId, placeOfTableId = null) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "TABLE_CONNECTIONS_REQUEST" });

      const {
        userLogin: { userInfo },
      } = getState();

      let url = `/restaurants/${restaurantId}/table-connections/`;

      if (placeOfTableId) {
        url += `?place_of_table=${placeOfTableId}`;
      }

      const { data } = await api.get(url, {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      });

      dispatch({
        type: "TABLE_CONNECTIONS_SUCCESS",
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: "TABLE_CONNECTIONS_FAIL",
        payload:
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
      });

      throw error;
    }
  };

export const updateTableConnections =
  (restaurantId, tableId, connectedTableIds) => async (dispatch, getState) => {
    try {
      dispatch({ type: "UPDATE_TABLE_CONNECTIONS_REQUEST" });

      const {
        userLogin: { userInfo },
      } = getState();

      const { data } = await api.put(
        `/restaurants/${restaurantId}/tables/${tableId}/connections/`,
        {
          connected_table_ids: connectedTableIds,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        },
      );

      dispatch({
        type: "UPDATE_TABLE_CONNECTIONS_SUCCESS",
        payload: data,
      });

      // Refresh the full connection list after updating one table
      dispatch(fetchTableConnections(restaurantId));

      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_TABLE_CONNECTIONS_FAIL",
        payload:
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
      });

      throw error;
    }
  };

export const sendTableReadyMessage = (token) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(TableReadyMessageStart());
    await api
      .post(`/restaurants/send_table_ready_message/${token}/`, config)
      .then((response) => dispatch(TableReadyMessageSuccess(response.data)));
  } catch (error) {
    dispatch(
      TableReadyMessageError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

export const resetAttendance = () => async (dispatch) => {
  dispatch(customerAttendUpdateReset());
};

export const updateArrangedTable =
  (token, status) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(startArrangedTableUpdate());
      await api
        .patch(
          `/restaurants/arrange_table/`,
          {
            token: token,
            status: status,
          },
          config,
        )
        .then((response) => dispatch(arrangedTableSuccess(response.data)));
    } catch (error) {
      dispatch(
        ArrangedTableError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const changeTableNumber =
  (token, table_name, token_to_exchange = "not_exchange") =>
  async (dispatch, getState) => {
    dispatch(startChangeTableNumber());
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const headers = userInfo
        ? {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          }
        : {};

      const { data } = await api.post(
        `/restaurants/change_table_number/${token}/${table_name}/${token_to_exchange}/`,
        {},
        { headers },
      );

      dispatch(changeTableNumberSuccess(data));
      return data; // allow component to .await this
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.message ||
        "Ocorreu um erro ao mudar a mesa.";
      dispatch(changeTableNumberError(msg));
      throw new Error(msg); // bubble up so UI can show it
    }
  };

const {
  startGetTutorialSteps,
  getTutorialStepsSuccess,
  getTutorialStepsError,
} = getTutorialStepsSlice.actions;

export const getTutorialSteps = (step) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(startGetTutorialSteps());
    await api
      .get(
        `/restaurants/tutorial_steps/`,
        {
          step: step,
        },
        config,
      )
      .then((response) => dispatch(getTutorialStepsSuccess(response.data)));
  } catch (error) {
    dispatch(
      getTutorialStepsError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

const {
  startCreateRestaurant,
  CreateRestaurantSuccess,
  CreateRestaurantError,
  CreateRestaurantReset,
} = createRestaurantSlice.actions;

export const createRestaurant =
  (params, reset = false) =>
  async (dispatch, getState) => {
    if (reset === true) {
      dispatch(CreateRestaurantReset());
    } else {
      try {
        dispatch(startCreateRestaurant());

        const {
          userLogin: { userInfo },
        } = getState();
        let config;
        if (userInfo) {
          config = {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${userInfo.token}`,
            },
          };
        } else {
          config = {
            headers: {
              nothing: "nothing",
            },
          };
        }
        await api
          .post(`/restaurants/create_restaurant/`, { params: params }, config)
          .then((response) => dispatch(CreateRestaurantSuccess(response.data)));
      } catch (error) {
        dispatch(
          CreateRestaurantError(
            error.response && error.response.data.detail
              ? error.response.data.detail
              : error.message,
          ),
        );
      }
    }
  };

const { startDestroyItem, destroyItemSuccess, destroyItemError } =
  destroyItemSlice.actions;

export const destroyItems = (id, item_model) => async (dispatch, getState) => {
  try {
    dispatch(startDestroyItem());

    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    if (item_model === "restaurants") {
      await api
        .delete(`/restaurants/details/${id}`, config)
        .then((response) => dispatch(destroyItemSuccess(response.data)));
      dispatch(fetchRestaurantList());
    }
  } catch (error) {
    dispatch(
      destroyItemError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

const {
  restaurantNotificationsStart,
  restaurantNotificationsSuccess,
  restaurantNotificationsError,

  createNotificationStart,
  createNotificationSuccess,
  createNotificationError,

  updateNotificationStart,
  updateNotificationSuccess,
  updateNotificationError,

  confirmNotificationStart,
  confirmNotificationSuccess,
  confirmNotificationError,
} = restaurantNotificationsSlice.actions;

export const getRestaurantNotificationsList =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(restaurantNotificationsStart());
      await api
        .get(`/restaurants/${restaurant_id}/restaurant_notifications/`, config)
        .then((response) =>
          dispatch(restaurantNotificationsSuccess(response.data)),
        );
    } catch (error) {
      dispatch(
        restaurantNotificationsError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const createRestaurantNotificationsList =
  (restaurant_id, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(createNotificationStart());

      await api
        .post(
          `/restaurants/${restaurant_id}/restaurant_notifications/`,
          params,
          config,
        )
        .then((response) => dispatch(createNotificationSuccess(response.data)));
      dispatch(getRestaurantNotificationsList(restaurant_id));
    } catch (error) {
      dispatch(
        createNotificationError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const updateRestaurantNotificationsList =
  (restaurant_id, pk, params) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(updateNotificationStart());
      await api
        .patch(
          `/restaurants/${restaurant_id}/restaurant_notifications/${pk}/`,
          params,
          config,
        )
        .then((response) => dispatch(updateNotificationSuccess(response.data)));
    } catch (error) {
      dispatch(
        updateNotificationError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const confirmNotification = (token) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(confirmNotificationStart());
    await api
      .patch(`/restaurants/confirm_notifications/${token}/`, {}, config)
      .then((response) => dispatch(confirmNotificationSuccess(response.data)));
  } catch (error) {
    dispatch(
      confirmNotificationError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

const {
  createPaymentIntentStart,
  createPaymentIntentSuccess,
  createPaymentIntentError,
  paymentIntentReset,
  confirmSubscriptionStart,
  confirmSubscriptionSuccess,
  confirmSubscriptionError,
  confirmSubscriptionReset,
  resetConfirmPayment,
  veriySubscriptionStart,
  veriySubscriptionSuccess,
  veriySubscriptionError,
  getSubscriptionPackStart,
  getSubscriptionPackSuccess,
  getSubscriptionPackError,
} = restaurantCreatePaymentIntentSlice.actions;

export const createPaymentIntent =
  (restaurant_id, subscription_number, payment_method) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(createPaymentIntentStart());
      await api
        .post(
          `/payments/create_payment_intent/${restaurant_id}/${subscription_number}/${payment_method}/`,
          {},
          config,
        )
        .then((response) =>
          dispatch(createPaymentIntentSuccess(response.data)),
        );
    } catch (error) {
      dispatch(
        createPaymentIntentError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const resetCreatePaymentIntent = () => async (dispatch) => {
  dispatch(resetConfirmPayment());
};

// actions/restaurantActions.js

export const confirmSubscriptionAction =
  (restaurant_id, subscription_number, token, isToSaveCard, isUpdate) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = userInfo
        ? {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        : { headers: { "Content-Type": "application/json" } };

      dispatch(confirmSubscriptionStart());

      // CALL API
      const { data } = await api.post(
        `/payments/confirm_subscription/${restaurant_id}/${subscription_number}/${token}/${isToSaveCard}/${isUpdate}/`,
        {},
        config,
      );

      // DISPATCH + RETURN so the component can read { subscription_id, status, clientSecret }
      dispatch(confirmSubscriptionSuccess(data));
      return data;
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        err?.message ||
        "Subscription failed";

      dispatch(confirmSubscriptionError(message));
      // IMPORTANT: rethrow so component's try/catch sees it
      throw new Error(message);
    }
  };

export const resetConfirmSubscription = () => async (dispatch) => {
  dispatch(confirmSubscriptionReset());
};

export const getSubscriptionsPacks = () => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(getSubscriptionPackStart());
    await api
      .get(`/restaurants/get_subscription_packs/`, config)
      .then((response) => dispatch(getSubscriptionPackSuccess(response.data)));
  } catch (error) {
    dispatch(
      getSubscriptionPackError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

export const verifySubscription =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(veriySubscriptionStart());
      const data = await api
        .post(`/payments/verify_subscription/${restaurant_id}/`, {}, config)
        .then((response) => dispatch(veriySubscriptionSuccess(response.data)));
      return data;
    } catch (error) {
      dispatch(
        veriySubscriptionError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  startCreatingFilters,
  createFiltersSuccess,
  createFiltersError,
  startFetchingFilters,
  fetchingFiltersSuccess,
  fetchingFiltersError,
  startDeletingFilters,
  deletingFiltersSuccess,
  deletingFiltersError,
  startUpdatingFilters,
  updatingFiltersSuccess,
  updatingFiltersError,
} = filtersSlice.actions;

export const createFilters =
  (restaurant_id, filterData) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          ...(userInfo && { Authorization: `Bearer ${userInfo.token}` }),
        },
      };

      dispatch(filtersSlice.actions.startCreatingFilters());

      const response = await api.post(
        `/restaurants/filters/${restaurant_id}/`,
        filterData,
        config,
      );

      dispatch(filtersSlice.actions.createFiltersSuccess(response.data));
    } catch (error) {
      dispatch(
        filtersSlice.actions.createFiltersError(
          error.response?.data?.detail || error.message,
        ),
      );
    }
  };

export const fetchFilters = (restaurant_id) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        ...(userInfo && { Authorization: `Bearer ${userInfo.token}` }),
      },
    };

    dispatch(filtersSlice.actions.startFetchingFilters());

    const response = await api.get(
      `/restaurants/filters/${restaurant_id}`,
      config,
    );

    dispatch(filtersSlice.actions.fetchingFiltersSuccess(response.data));
  } catch (error) {
    dispatch(
      filtersSlice.actions.fetchingFiltersError(
        error.response?.data?.detail || error.message,
      ),
    );
  }
};

export const deleteFilters =
  (restaurant_id, filters_ids) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: userInfo ? `Bearer ${userInfo.token}` : undefined,
        },
      };

      dispatch(filtersSlice.actions.startDeletingFilters());

      await api.delete(`/restaurants/filter/delete/${restaurant_id}/`, {
        data: filters_ids,
        headers: config.headers,
      });

      dispatch(filtersSlice.actions.deletingFiltersSuccess(filters_ids));
    } catch (error) {
      dispatch(
        filtersSlice.actions.deletingFiltersError(
          error.response?.data?.detail || error.message,
        ),
      );
    }
  };

export const updateFilters =
  (restaurant_id, filtersData) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          ...(userInfo && { Authorization: `Bearer ${userInfo.token}` }),
        },
      };

      dispatch(startUpdatingFilters());

      const response = await api.patch(
        `/restaurants/filter/update/${restaurant_id}/`,
        filtersData,
        config,
      );

      dispatch(updatingFiltersSuccess(response.data));
    } catch (error) {
      dispatch(
        updatingFiltersError(error.response?.data?.detail || error.message),
      );
    }
  };
